import React, { forwardRef } from 'react';

// Using React.SVGProps<SVGSVGElement> to allow all native SVG attributes,
// plus custom optional props for size, color, and title for convenience.
export interface IconProps extends React.SVGProps<SVGSVGElement> {
  color?: string; // Overrides inherited currentColor if provided
  size?: string | number;
  title?: string;
}

const LogoFigma = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size = 20, title, className, style, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        // The default SVG attributes (fill, stroke, strokeWidth, etc.) 
        // are REMOVED here so the raw SVG paths determine the appearance.
        className={className}
        style={color ? { color, ...style } : style} // Apply color via CSS property for inheritance if set
        {...props}
      >
        {/* If the original SVG has complex colors/fills, we want them here. */}
        {title && <title>{title}</title>}
        <path d="M8.00342 8C8.00342 7.29275 8.28437 6.61448 8.78447 6.11438C9.28456 5.61428 9.96284 5.33333 10.6701 5.33333C11.3773 5.33333 12.0556 5.61428 12.5557 6.11438C13.0558 6.61448 13.3368 7.29275 13.3368 8C13.3368 8.70724 13.0558 9.38552 12.5557 9.88562C12.0556 10.3857 11.3773 10.6667 10.6701 10.6667C9.96284 10.6667 9.28456 10.3857 8.78447 9.88562C8.28437 9.38552 8.00342 8.70724 8.00342 8Z" fill="#1ABCFE"></path>
                                <path d="M2.66992 13.3333C2.66992 12.6261 2.95087 11.9478 3.45097 11.4477C3.95107 10.9476 4.62934 10.6667 5.33659 10.6667H8.00326V13.3333C8.00326 14.0406 7.7223 14.7189 7.22221 15.2189C6.72211 15.719 6.04383 16 5.33659 16C4.62934 16 3.95107 15.719 3.45097 15.2189C2.95087 14.7189 2.66992 14.0406 2.66992 13.3333Z" fill="#0ACF83"></path>
                                <path d="M8.00342 0V5.33333H10.6701C11.3773 5.33333 12.0556 5.05238 12.5557 4.55228C13.0558 4.05219 13.3368 3.37391 13.3368 2.66667C13.3368 1.95942 13.0558 1.28115 12.5557 0.781049C12.0556 0.280952 11.3773 0 10.6701 0L8.00342 0Z" fill="#FF7262"></path>
                                <path d="M2.67017 2.66667C2.67017 3.37391 2.95112 4.05219 3.45121 4.55228C3.95131 5.05238 4.62959 5.33333 5.33683 5.33333H8.0035V0H5.33683C4.62959 0 3.95131 0.280952 3.45121 0.781049C2.95112 1.28115 2.67017 1.95942 2.67017 2.66667Z" fill="#F24E1E"></path>
                                <path d="M2.66992 8C2.66992 8.70724 2.95087 9.38552 3.45097 9.88562C3.95107 10.3857 4.62934 10.6667 5.33659 10.6667H8.00326V5.33333H5.33659C4.62934 5.33333 3.95107 5.61428 3.45097 6.11438C2.95087 6.61448 2.66992 7.29275 2.66992 8Z" fill="#A259FF"></path>
      </svg>
    );
  }
);

LogoFigma.displayName = 'LogoFigma';

export default LogoFigma;
